import style from './style.module.scss';

export const WinnerBanner = ({ winner }) => {
    return (
        <div className={style.columns}>
            <div className={style.left}>
                <p>
                    <span>👑</span> Gagnant(e) du concours
                </p>
            </div>

            <div className={style.divider} />

            <div className={style.right}>
                <p>{winner}</p>
            </div>
        </div>
    );
};
